import axios from 'axios'

import { reatailmediaApi } from '../api'

export const spendReportsServiceKey = 'spend-reports'

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type PacingStatus =
  | 'overpacing'
  | 'on_track'
  | 'underpacing'
  | 'critical_underpacing'

export interface PacingMetric {
  value: number
  goal: number
  percentage: number
  pacing: PacingStatus
}

export interface SpendOverviewResponse {
  currency: string
  campaign_name: string
  campaign_status: string
  campaign_start_at: string
  campaign_end_at?: string
  daily: PacingMetric
  weekly: PacingMetric
  total: PacingMetric
  forecast: PacingMetric
  monthly?: PacingMetric
  monthly_forecast?: PacingMetric
}

interface TotalSpendDataPoint {
  date: string
  cumulative: number | null
  forecast: number | null
  goal: number
  forecast_upper_bound: number | null
  forecast_lower_bound: number | null
}

export interface TotalSpendResponse {
  currency: string
  elapsed_index: number
  reference_timestamp: string
  data: TotalSpendDataPoint[]
}

interface DailySpendDataPoint {
  date: string
  consumed: number | null
  remaining: number | null
  overspend: number | null
  impression_share?: number | null
  impression_share_settled_day?: string | null
  lost_is_rank?: number | null
  lost_is_budget?: number | null
}

export interface DailySpendResponse {
  currency: string
  elapsed_index: number
  daily_budget: number
  data: DailySpendDataPoint[]
}

interface HourlySpendDataPoint {
  hour: number
  consumed: number | null
  remaining: number | null
  overspend: number | null
}

export interface HourlySpendResponse {
  currency: string
  elapsed_index: number
  daily_budget: number
  hourly_goal: number
  data: HourlySpendDataPoint[]
}

interface CumulativeDailyDataPoint {
  hour: number
  cumulative: number | null
  forecast: number | null
  goal: number
  forecast_upper_bound: number | null
  forecast_lower_bound: number | null
}

export interface CumulativeDailyResponse {
  currency: string
  elapsed_index: number
  data: CumulativeDailyDataPoint[]
}

// ---------------------------------------------------------------------------
// Services
// ---------------------------------------------------------------------------

export const getOverviewService = (
  campaignId: string,
  params: { start_date: string; end_date: string }
) =>
  axios.get<SpendOverviewResponse>(
    `${reatailmediaApi}/report/budget-pacing/${campaignId}/overview`,
    { params }
  )

export const getTotalSpendService = (
  campaignId: string,
  params: { start_date: string; end_date: string }
) =>
  axios.get<TotalSpendResponse>(
    `${reatailmediaApi}/report/budget-pacing/${campaignId}/total-spend`,
    { params }
  )

export const getDailySpendService = (
  campaignId: string,
  params: { start_date: string; end_date: string }
) =>
  axios.get<DailySpendResponse>(
    `${reatailmediaApi}/report/budget-pacing/${campaignId}/daily-spend`,
    { params }
  )

export const getHourlySpendService = (
  campaignId: string,
  params: { date: string }
) =>
  axios.get<HourlySpendResponse>(
    `${reatailmediaApi}/report/budget-pacing/${campaignId}/hourly-spend`,
    { params }
  )

export const getCumulativeDailyService = (
  campaignId: string,
  params: { date: string }
) =>
  axios.get<CumulativeDailyResponse>(
    `${reatailmediaApi}/report/budget-pacing/${campaignId}/cumulative-daily`,
    { params }
  )
